<div class="modal-header">
  <h5 class="modal-title">Invoice Detail</h5>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="detail mb-3">

    <div class="row mt-5 mb-5">
      <div class="col">
        <b>Status:</b>
      </div>
      <div class="col text-capitalize">
        {{ invoice.status | pendingStatusToWaitingForApproval }}
      </div>
    </div>
    <div class="row mt-5 mb-5"  *ngIf="invoice?.status === 'rejected' && !!invoice?.rejection_reason">
      <div class="col">
        <b>Rejection reason:</b>
      </div>
      <div class="col">
        {{ invoice.rejection_reason }}
      </div>
    </div>

    <div class="row mt-5 mb-5">
      <div class="col">
        <b>Created At:</b>
      </div>
      <div class="col">
        {{invoice.created_at | date:'MMM d, y':'utc'  }}
      </div>
    </div>
    <div class="row mt-5 mb-5" *ngIf="invoice.created_by_name">
      <div class="col">
        <b>Created By:</b>
      </div>
      <div class="col">
        {{invoice.created_by_name }}
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center mb-2" *ngIf="invoice.file as shipmentFile">
    <div>
      <i class="fa fa-paperclip"></i>
    </div>
    <div class="d-flex flex-column text-center">
      <a (click)="getFile(shipmentFile)">
        {{ shipmentFile.file_name }}
      </a>
      {{ shipmentFile.file_size | fileSize }}
    </div>
  </div>

  <div *ngIf="invoice.description" class="jumbotron p-2">
    {{ invoice.description }}
  </div>

  <table *ngIf="invoice.line_items?.length" class="table table-bordered">
    <thead>
    <tr>
      <th>Product Name</th>
      <th>Quantity Billed</th>
    </tr>
    </thead>

    <tbody>
    <tr *ngFor="let line_item of invoice.line_items">
      <td>
        {{ line_item.product_name }}
      </td>
      <td>
        {{ line_item.quantity_invoiced }}
      </td>
    </tr>
    </tbody>
  </table>

  <div class="text-center" *ngIf="invoice.status === 'pending' && companyType === 'customer'">
    <button class="btn btn-success" (click)="acceptOrRejectInvoice(invoice, true)">
      Approve
    </button>
    <button class="btn btn-danger" (click)="acceptOrRejectInvoice(invoice, false)">
      Reject
    </button>
  </div>

</div>

<div class="modal-footer">
  <button class="btn btn-default" (click)="activeModal.dismiss()">
    Close
  </button>
</div>
